/**
 * @author vishwadeep.kapoor
 */

import fbAnalytics from './fbEventTracker';
import { intializeTracker } from './googleEventTracking';

/**
 * @constant
 */
const KEYS = {
  PROD_GOOGLE: 'UA-74150809-1',
  DEV_GOOGLE: 'UA-74150809-2',
  TESTING: 'UA-128962828-1',
};

/**
 * @func fbAnalytics/intializeTracker and for tracking the events
 */
export const initilizeAnalytics = () => {
  if (process.env.NODE_ENV === 'development') {
    // intializeTracker(KEYS.DEV_GOOGLE);
  } else if (process.env.NODE_ENV === 'production') {
    // intializeTracker(KEYS.PROD_GOOGLE);
    // fbAnalytics.initizeFBtracker();
  } else {
    console.log('false');
  }
};



// WEBPACK FOOTER //
// client/devUtils/analytics/index.js